import React from 'react'
import { connect } from 'react-redux'


const styles = {
  imageWrapper: {
    textAlign: 'center',
    margin: '10px',
  },
  image: {
    height: '300px',
    width: 'auto',
  },
}

class ImageElement extends React.Component {

  render() {
    const { element, real_answer } = this.props
    if (real_answer) {
      return (
        <div style={styles.imageWrapper}>
          <img style={styles.image} src={element.media_url} alt={`Foto ${element.id}`} />
        </div>
      )
    }
    return (
      <div style={styles.imageWrapper}>
        <img style={styles.image} src={element.media_url} alt={`Foto ${element.id}`} />
      </div>
    )
  }

}

const mapStateToProps = state => ({
  ...state,
})

const mapDispatchToProps = () => ({
})


export default connect(mapStateToProps, mapDispatchToProps)(ImageElement)



// WEBPACK FOOTER //
// ./src/components/MissionShow/MissionPage/FormPage/PageElement/ImageElement/index.jsx